import React from 'react';
import { Typography, Card } from 'antd';
import IndividualInformHeader from '../components/individualInformHeader/individualInformHeader';
import AnswersList from '../components/answersList/answersList';
import AutoSizeTitle from '../components/autoSizeTitle/AutoSizeTitle';

const { Title } = Typography;

const PageTextualAnswersIndividual = ({
    individualResult,
    selectedEvaluation,
    orgLogo,
    title,
    question,
    answers,
    pageNumber
}) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info" style={{ position: "relative" }}>
                    <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />
                    <Card
                        style={{
                            border: 'none',
                            backgroundColor: 'white',
                            boxShadow: 'none',
                        }}
                        styles={{ body: { padding: '0' } }}
                    >
                        <Title
                            level={4}
                            style={{ color: '#339C98', marginBottom: 16, width: 'calc(100% - 150px)' }}
                        >
                            {title}
                        </Title>
                        <AnswersList
                            question={question}
                            answers={answers}
                            pagePos={0}
                            isAnswer={true}
                        />
                    </Card>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageTextualAnswersIndividual;
